export type FaqItem = { question: string; answer: string };

type FaqSchema = ReturnType<typeof buildFaqList>;

export const buildFaqList = (faqData: FaqItem[]) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity:
    (faqData || []).map((item) => {
      return {
        "@type": "Question",
        name: item.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: item.answer,
        },
      };
    }) || [],
});

export const mergeFaqSchemas = (...schemas: FaqSchema[]): FaqSchema => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: schemas.flatMap((s) => s.mainEntity),
});